import { ToggleSwitch } from '../toggle-switch';
import { fontWeights, Paragraph } from '../typography';

export const ViewToggleItem = ({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => {
  return (
    <div className='flex items-center justify-between gap-3 px-3 py-2.5'>
      <Paragraph weight={fontWeights.medium}>{label}</Paragraph>
      <ToggleSwitch height={26} handleDiameter={20} checked={checked} onChange={onChange} />
    </div>
  );
};
